/**
 * Aba Quick replies em leitura (PR2).
 *
 * Lê `quickReplies` defensivamente (wire-shape duplo — R15) e renderiza cada
 * card: label · texto · atalho (quando houver). Campos do protótipo sem fonte
 * (categoria, uso 30d, isAction, ivr, sugestão IA) são omitidos — zero dado
 * falso. SEM drag/editar (read-only — PR4). Empty-state honesto.
 */

import { readList } from '../playbook-labels';

import type { PlaybookDto, PlaybookQuickReply } from '../types';

function QuickReplyCard({ qr }: { qr: PlaybookQuickReply }): JSX.Element {
  return (
    <div className="pb-qr-card">
      <div className="pb-qr-card__label">“{qr.label}”</div>
      <div className="pb-qr-card__text">{qr.text}</div>
      {qr.shortcut !== undefined && qr.shortcut !== '' && (
        <div className="pb-qr-card__meta">
          atalho: <kbd className="pb-kbd">/{qr.shortcut}</kbd>
        </div>
      )}
    </div>
  );
}

export function TabQuickReplies({ playbook }: { playbook: PlaybookDto }): JSX.Element {
  const quickReplies = readList<PlaybookQuickReply>(playbook.quickReplies);

  return (
    <div className="pb-panel" role="tabpanel" aria-label="Quick replies">
      <h2 className="pb-panel__title">Quick replies</h2>

      {quickReplies.length > 0 ? (
        <div className="pb-qr-list">
          {quickReplies.map((qr, i) => (
            <QuickReplyCard key={qr.id ?? i} qr={qr} />
          ))}
        </div>
      ) : (
        <p className="pb-read-value pb-read-value--muted">Nenhuma quick reply definida</p>
      )}
    </div>
  );
}
